"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBar = NavBar;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const NavItem_1 = require("./NavItem");
const useStyles = (0, react_jss_1.createUseStyles)({
    navBar: {
        display: "flex",
        flexDirection: "row",
    },
});
function NavBar({ items, active, onSelect, }) {
    const styles = useStyles();
    return (React.createElement("nav", { className: styles.navBar }, items.map((item) => (React.createElement(NavItem_1.NavItem, { key: item.key, icon: item.icon, isActive: active === item.key, onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(item.key) }, item.children)))));
}
